/* eslint-disable prefer-const */
import React, { useState, useEffect } from 'react'
import { Formik, useFormikContext } from 'formik'
import ValidationSchema from '../validation/validationSchema'
import PayFields from './payFields'
import { useCustomContext } from '../../Context'
import { PathParams } from '../../config'
import {
  IItemTypesR,
  IInitialValuesForm,
  IApiResponse,
  IProcessMerchants,
} from '../../interfaces/payDetails'

// use this function to get mock data
// import Data from './payDirectMock.json'
// const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))
// const fakeMerchantSearch = async () => {
//   const x = await sleep(2000)

//   return Data
// }
const PayDirectFormWrapper = ({
  children,
  autoComplete,
}: {
  children: React.ReactNode
  autoComplete?: string
}) => {
  const { handleSubmit } = useFormikContext()
  return (
    <form autoComplete={autoComplete} onSubmit={handleSubmit}>
      {children}
    </form>
  )
}

function getSecondsToday() {
  let now = new Date()

  let today = new Date(now.getFullYear(), now.getMonth(), now.getDate())

  let diff = +now - +today
  return Math.round(diff / 1000)
}

export default function PayDirForm() {
  const { apiRequest } = useCustomContext()
  const [apiResponse, setApiResponse] = useState<IApiResponse[]>([] as IApiResponse[])

  useEffect(() => {
    const merchantSearch = async () => {
      try {
        const response: IProcessMerchants[] = (await apiRequest(
          'get',
          PathParams.GET_API_MERCHANT_SEARCH,
          false,
          true,
          {},
        )) as unknown as IProcessMerchants[]
        return response
      } catch (error) {
        return Promise.reject(error)
      }
    }
    merchantSearch().then((z) => {
      const apiResp = (z || []).filter((e) => {
        return e.activeFlg === true
      })
      // const apiResp = (z || []).map((e) => {
      //   return { title: e.title, itemTypes: e.itemTypes, id: e.id }
      // })
      setApiResponse(apiResp)
    })
  }, [])

  return (
    <Formik
      initialValues={
        {
          office: null,
          itemType: null,
          itemList: {} as IItemTypesR,
          list: {} as IItemTypesR,
          amount: '',
          id: -1,
        } as IInitialValuesForm
      }
      validationSchema={ValidationSchema}
      onSubmit={(values) => {
        const itemsObj: Array<IItemTypesR> = []
        itemsObj.push({
          ...values.itemList,
          itemType: values.itemType ? values.itemType.typeDesc : '',
          amount: parseFloat(values.amount),
        })

        const currentDate = new Date().toISOString()
        const currentTime = new Date(getSecondsToday() * 1000).toISOString().slice(11, 19)
        const processTrans = async () => {
          try {
            const response: any = await apiRequest(
              'post',
              PathParams.POST_APT_TRANSACTION,
              false,
              true,
              {
                transactionDt: currentDate,
                transactionTm: currentTime,
                merchant: values.id,
                sourceCd: 'W',
                items: itemsObj,
              },
            )

            return response.transactionId
          } catch (err) {
            return Promise.reject(err)
          }
        }
        processTrans()
          .then((res) => {
            //for now run the govrec pay on host 3001, CHANGE IN PROD

            const baseURL =
              import.meta.env.REACT_APP_PAY_BASE_URL_PROD !== ''
                ? import.meta.env.REACT_APP_PAY_BASE_URL_PROD
                : 'https://localhost:3003/pay/'

            window.location.href = `${baseURL}${res}?redirect_url=${encodeURIComponent(
              window.location.href,
            )}`
          })
          .catch((err) => Promise.reject(err))
      }}
    >
      <PayDirectFormWrapper autoComplete='off'>
        <PayFields apiResponse={apiResponse} />
      </PayDirectFormWrapper>
    </Formik>
  )
}
